'use strict';

// Menu configs
(()=>{
	'use strict';

	const bodyWidth = $(window).width();
	const bodyHeigth = $(window).height();
	const $body = $('.content-hero');
	let posY, $menu, menuToHide;





	$('.js-open-submenu-products').on('click', (e)=> {
		e.preventDefault();
		openSubMenu('products');
	});

	$('.js-open-menu-my-account').on('click', (e)=> {// XXX:
		e.preventDefault();
		openSubMenu('my-account');
	});


	const bodyFreezeScroll = () => {
		if (bodyWidth > 740) return;
		posY = window.pageYOffset;
		$("html, body").scrollTop(0);
		$('.content-hero').addClass('fixed-mobile').css("top", -posY + 70);
	}

	const bodyUnfreezeScroll = () => {
		if (bodyWidth > 740) return;
		$('.content-hero').removeClass('fixed-mobile');
		$("html, body").scrollTop(posY);
	}


	const openSubMenu = (name) => {
		$('.js-open-menu-my-account').removeClass('active');

		if(name === 'products') {
			$menu = $('.submenu-products');
			menuToHide = $('.menu-my-account');

		} else {
			$menu = $('.menu-my-account');
			menuToHide = $('.submenu-products');
			$('.js-open-menu-my-account').addClass('active');
		}

		$(menuToHide).removeClass('open-menu')

		if($($menu).hasClass('open-menu')) {
			//close menu
			bodyUnfreezeScroll()
			$($menu).removeClass('open-menu').addClass('close-menu')
			$('.menu-overlay').remove();
			setTimeout(function(){
				$($menu).removeClass('close-menu');
			},500)

			if(name === 'my-account') {
				$('.js-open-menu-my-account').removeClass('active');

				if (bodyWidth <= 740) {
					$('.js-open-menu-my-account').find('span').html('MINHA CONTA');
				}
			}
		} else {
			//open menu
	        bodyFreezeScroll()
			$($menu).removeClass('close-menu').addClass('open-menu');
			if(name === 'my-account') {
				if (bodyWidth <= 740) {
					$('.js-open-menu-my-account').find('span').html('<i class="fa fa-x fa-2" aria-hidden="true"></i>');
				}
			}else{
				if (bodyWidth <= 740) {
					$('.js-open-menu-my-account').find('span').html('MINHA CONTA');
				}
			}
		}

	}


	$('body').on('click', '.content-hero', function(event) {
		if($('.open-menu').hasClass('open-menu')){
			event.preventDefault();
			$('.open-menu').removeClass('open-menu').addClass('close-menu');
			$('.js-open-menu-my-account').removeClass('active');
			$('.open-menu').removeClass('open-menu');
			$('.menu-overlay').remove();
		}
	});


	const myNavBar = {
		flagFixed: true,
		timer: null,

		add: function() {
			if(this.flagFixed) {
				if( !$('.menu-hero').hasClass('show-menu-scrolling') ){
					$('.menu-hero').addClass('show-menu-scrolling');
				}
				this.flagAdd = false;
			}
		},
		remove: function() {
			$('.menu-hero').removeClass('show-menu-scrolling');
			this.flagFixed = true;
		}
	};


	const menuOffsetManager = () => {
		//only hide and show top menu on home page and desktop screens
		if( $("body.home").length != 0 && bodyWidth > 740){
			const yOffset = 80;
			let currYOffSet = window.pageYOffset;
			if(yOffset < currYOffSet) {
				myNavBar.add();
			}else{
				myNavBar.remove();
			}
		}
	}

	$(window).scroll((event)=> {
		menuOffsetManager();
	});


	menuOffsetManager();

	// $(window).resize(function(event) {
	// 	$('.submenu-products').removeClass('open-menu');
	// 	$('.menu-my-account').removeClass('open-menu');
	// });






})();
